;(function ($) {

	$(document).ready(function(){

        $('div.editable').on('click', function(e){
            // console.log('clicking input');
            $(this).find('input').attr("disabled", false);
            $(this).find('span.edit').hide();
        });

        modifyContacts();
        requestChangeForm();

        $('.tooltip-edit, .tooltip-del').tooltipster({
            interactive: true,
            theme: 'tooltipster-shadow',
            distance: 10,
            side: 'bottom'
        });
	});



	$(window).load(function(){		

	});

    //functions
    function requestChangeForm(){
        $( "#member-request-change-form" ).validate({
            rules: {
                // "rmc-voter-auth-name": {
				// 	required: true
                // },
                // "rmc-voter-auth-title": {
				// 	required: true
                // },
                // "rmc-voter-auth-date": {
				// 	required: true
				// }
            },
            submitHandler: function(form) {
                var sz = $(form).serializeArray();
                // console.log(sz);

                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        "action": "request_change_form", 
                        data: sz
                    },
                    beforeSend : function() {
                        //do something
                        $('.finish-editing').hide();
                        $('.form-submitting-row').css('display', 'flex');
                    },
                    success: function(response) {
                        // console.log(response);
                        //redirect to confirmation page
                        if (response == 'confirmed') {
                            //local
                            //location.href = '/request-contact-change-confirmation/';
                            //production
                            location.href = '/member/request-contact-change-confirmation/';
                        } 
                    }    
                });

                return false;
                
            }
        });
    }

    function modifyContacts(){
        var count = 0;
        var limit = 100;
        $('.select-contact').on('change', function(){
            // console.log($(this).val());
            if ($(this).data('count') !== '') {
                count = $(this).data('count');
            }
            var type = $(this).data('type');
            //console.log(type);
            switch (type) {
                case 'primary-contact':
                case 'pc-underwriting':
                case 'wc-underwriting':      
                case 'pc-claims':
                case 'wc-claims':  
                case 'accounts-payable':  
                case 'ct-attorney':  
                    limit = 2;
                    break;
                case 'munc-admin':
                case 'munc-clerk':
                case 'loss-control':    
                    limit = 1; 
                    break;   
                default:
                    break;
            }
            if ($(this).val() == 'new') {
                count++;
                //console.log(count);
                
                if (count == limit) {
                    $(this).attr("disabled", true);
                }

                var html = '<div class="row one-contact-row new-contact">'+
                    '<div class="col-xs-12 col-md-6 left">'+
                        '<h4>Name:</h4>'+
                        '<input type="text" name="rmc-'+type+'-name-'+count+'" id="rmc-name-'+type+'-'+count+'" class="rmc-name" placeholder="Name" value="">'+
                        '<h4>Email:</h4>'+
                        '<input type="text" name="rmc-'+type+'-email-'+count+'" id="rmc-email-'+type+'-'+count+'" class="rmc-email" placeholder="Email" value="">'+
                    '</div>'+
                    '<div class="col-xs-12 col-md-6 right">'+
                        '<h4>Title:</h4>'+
                        '<input type="text" name="rmc-'+type+'-title-'+count+'" id="rmc-title-'+type+'-'+count+'" class="rmc-title" placeholder="Title" value="">'+
                        '<h4>Phone:</h4>'+
                        '<input type="text" name="rmc-'+type+'-phone-'+count+'" id="rmc-phone-'+type+'-'+count+'" class="rmc-phone" placeholder="Phone" value="">'+
                    '</div>'+
                    '<div class="col-xs-12">'+
                        '<div class="save-to-list new-'+count+'" data-type="'+type+'" data-count="'+count+'">'+
                            '<i class="fa fa-plus" aria-hidden="true"></i>'+
                            '<p>Save contact to list</p>'+
                        '</div>'+
                    '</div>'+
                '</div>';
                $('#'+type+'-rows').append(html);
            } else {
                //ADD CONTACT FROM LIST
                count++;
                var list_name = $(this).val();
                var list_email = $(this).find(':selected').data('email');
                var list_title = $(this).find(':selected').data('title');
                var list_phone = $(this).find(':selected').data('phone');

                if (count == limit) {
                    $(this).attr("disabled", true);
                }

                var html = '<div class="row one-contact-row list-contact">'+
                    '<div class="col-xs-12 col-md-6 left">'+
                        '<h4>Name:</h4>'+
                        '<input type="text" name="rmc-'+type+'-name-'+count+'" id="rmc-name-'+type+'-'+count+'" class="rmc-name" placeholder="Name" value="'+list_name+'">'+
                        '<h4>Email:</h4>'+
                        '<input type="text" name="rmc-'+type+'-email-'+count+'" id="rmc-email-'+type+'-'+count+'" class="rmc-email" placeholder="Email" value="'+list_email+'">'+
                    '</div>'+
                    '<div class="col-xs-12 col-md-6 right">'+
                        '<h4>Title:</h4>'+
                        '<input type="text" name="rmc-'+type+'-title-'+count+'" id="rmc-title-'+type+'-'+count+'" class="rmc-title" placeholder="Title" value="'+list_title+'">'+
                        '<h4>Phone:</h4>'+
                        '<input type="text" name="rmc-'+type+'-phone-'+count+'" id="rmc-phone-'+type+'-'+count+'" class="rmc-phone" placeholder="Phone" value="'+list_phone+'">'+
                    '</div>'+
                '</div>';
                $('#'+type+'-rows').append(html);
            }
            //reset select
            $(this).val('');
            //add to select count
            $(this).data('count', count);
            $(this).attr('count', count);
            
            //add to contact list
            $('#'+type+'-rows').on('click', '.save-to-list.new-'+count+'', function(e){
                var tcount = $(this).data('count');
                // console.log(tcount);
                var saved_content = {
                    'name': $('#rmc-name-'+type+'-'+tcount+'').val(),
                    'email': $('#rmc-email-'+type+'-'+tcount+'').val(),
                    'title': $('#rmc-title-'+type+'-'+tcount+'').val(),
                    'phone': $('#rmc-phone-'+type+'-'+tcount+'').val()
                }
                // console.log(saved_content);
                //append to select
                $('select[name="select_contact"]').append('<option data-email="'+saved_content.email+'" data-title="'+saved_content.title+'" data-phone="'+saved_content.phone+'" value="'+saved_content.name+'">'+saved_content.name+'</option>');
                $(this).html('<p>Saved</p>');
            });

        });

        $('.edit-one-contact').click(function(e){
            e.preventDefault();
            var type = $(this).data('type');
            // console.log(type);
            $('input#rmc-name-'+type+'').attr("disabled", false);
            $('input#rmc-email-'+type+'').attr("disabled", false);
            $('input#rmc-title-'+type+'').attr("disabled", false);
            $('input#rmc-phone-'+type+'').attr("disabled", false);
        });
        
        $('.remove-one-contact').click(function(e){
            e.preventDefault();
            var type = $(this).data('type');
            // console.log(type);
            //undisable, strikethrough
            $('input#rmc-name-'+type+'').attr("disabled", false).addClass('remove');
            $('input#rmc-email-'+type+'').attr("disabled", false).addClass('remove');
            $('input#rmc-title-'+type+'').attr("disabled", false).addClass('remove');
            $('input#rmc-phone-'+type+'').attr("disabled", false).addClass('remove');
            //get values
            var name = $('input#rmc-name-'+type+'').val();
            var email = $('input#rmc-email-'+type+'').val();
            var title = $('input#rmc-title-'+type+'').val();
            var phone = $('input#rmc-phone-'+type+'').val();
            //add 'Remove' to values
            $('input#rmc-name-'+type+'').val('Remove: '+name);
            $('input#rmc-email-'+type+'').val('Remove: '+email);
            $('input#rmc-title-'+type+'').val('Remove: '+title);
            $('input#rmc-phone-'+type+'').val('Remove: '+phone);
        });
    }

})(jQuery);